<template>
<div class="broadcast-message-component fixed bottom-0 inset-x-0 text-center bg-primary-darker z-broadcast-message" v-if="!closed">
  <div class="broadcast-message-content relative">
    <button type="button" class="close-broadcast-message absolute right-0 p-4 text-white font-bold text-2xl"
            @click="close"
            title="Закрыть сообщение"
    >&times;</button>
    <p v-html="message.message" class="text-white px-12 py-8"></p>
  </div>
</div>
</template>

<script>
export default {
  props: {
    message: {
      required: true,
      type: Object,
    },

    closed: {
      required: true,
      type: Boolean,
    },
  },

  methods: {
    close() {
      this.$emit('closed')
    },
  },
}
</script>
